module.exports = function() {
  return new Worker(__webpack_public_path__ + "073fb6ceea2fb1e464d2.worker.js");
};